import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Search Icon',
};

export const SearchCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.28585 1.42871C4.94647 1.42871 1.42871 4.94647 1.42871 9.28585C1.42871 13.6252 4.94647 17.143 9.28585 17.143C11.1984 17.143 12.9513 16.4597 14.3138 15.3239L17.3523 18.3624C17.6312 18.6413 18.0835 18.6413 18.3624 18.3624C18.6414 18.0834 18.6414 17.6312 18.3624 17.3522L15.3239 14.3137C16.4597 12.9512 17.143 11.1983 17.143 9.28585C17.143 4.94647 13.6252 1.42871 9.28585 1.42871ZM2.85728 9.28585C2.85728 5.73545 5.73545 2.85728 9.28585 2.85728C12.8363 2.85728 15.7144 5.73545 15.7144 9.28585C15.7144 12.8363 12.8363 15.7144 9.28585 15.7144C5.73545 15.7144 2.85728 12.8363 2.85728 9.28585Z"
            />
        </SvgIcon>
    );
};
